



































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteEquipamentosStore from '@/components/Suporte/Store/SuporteEquipamentosStore'
import { onlyNumber } from '@/utils/common'

@Component
export default class ComponentModalSuporteEquipamento extends Vue {
  loadSaveOrUpdateEquipamento: boolean = false

  get getSuporteEquipamentosStore() {
    return getModule(SuporteEquipamentosStore, this.$store)
  }

  get loadingSaveOrUpdateEquipamento() {
    return this.loadSaveOrUpdateEquipamento
  }

  set loadingSaveOrUpdateEquipamento(value: boolean) {
    this.loadSaveOrUpdateEquipamento = value
  }

  get showModalEquipamento() {
    return this.getSuporteEquipamentosStore.modal.equipamento
  }

  set showModalEquipamento(value: boolean) {
    this.getSuporteEquipamentosStore.setModal({ name: 'equipamento', value })
  }

  $refs!: {
    formEquipamento: any
  }

  formEquipamentoRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    quantidade: [(v: any) => this.validateQuantidade(v)],
    grupoEquipamentoId: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  validateQuantidade(value: any) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    if (+value < 1) return 'A quantidade deve ser maior que zero.'
    return true
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async saveOrUpdateEquipamento() {
    this.loadingSaveOrUpdateEquipamento = true

    if (this.$refs.formEquipamento.validate()) {
      const { mode } = this.getSuporteEquipamentosStore

      const response = await this.getSuporteEquipamentosStore.upsertEquipamentoByHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Equipamento ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteEquipamentosStore.getEquipamentoPagedSearch(this.getSuporteEquipamentosStore.paginationEquipamentos)
        this.showModalEquipamento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o equipamento ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateEquipamento = false
  }

  @Watch('showModalEquipamento')
  onChangeshowModalEquipamento(value: boolean) {
    if (!value) {
      this.getSuporteEquipamentosStore.clearEquipamento()
      this.getSuporteEquipamentosStore.setMode({ mode: 'CREATE' })
      this.$refs.formEquipamento.resetValidation()
    }
  }
}
